import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { z } from "zod";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetWarehouseVendorQueryOptions } from "@/requests/gen/react-query/warehouse-vendor";
import WarehouseVendorCreateForm from "../-form";
import { WarehouseVendorCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

const searchSchema = z.object({
  warehouseId: z.number().optional(),
  vendorId: z.number().optional(),
});

export const Route = createFileRoute(
  "/_private/_warehouse-360/warehouse-vendor/$warehouseVendorId/edit",
)({
  validateSearch: searchSchema,
  loader: ({ context: { queryClient }, params: { warehouseVendorId } }) =>
    queryClient.ensureQueryData(
      getGetWarehouseVendorQueryOptions(numericId(warehouseVendorId)),
    ),
  component: WarehouseVendorEditPage,
});

function WarehouseVendorEditPage() {
  const { warehouseVendorId } = Route.useParams();
  const { data: warehouseVendor } = useSuspenseQuery(
    suspenseOptions(
      getGetWarehouseVendorQueryOptions(numericId(warehouseVendorId)),
    ),
  );

  return (
    <div>
      <title>Edit Warehouse Vendor - Legrande Health Portal</title>
      <WarehouseVendorCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Warehouse Vendor Link</CardTitle>
          <CardDescription>
            Link a warehouse item to a vendor who supplies it.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {warehouseVendor && (
            <WarehouseVendorCreateForm warehouseVendor={warehouseVendor} />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
